import { render, staticRenderFns } from "./ArpFeedback.vue?vue&type=template&id=54ec9435&scoped=true&"
import script from "./ArpFeedback.vue?vue&type=script&lang=js&"
export * from "./ArpFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ArpFeedback.vue?vue&type=style&index=0&id=54ec9435&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec9435",
  null
  
)

export default component.exports